import React from 'react';
import Accordion from '../../../Accordion/Accordion';
import styles from './EstimatedTotal.module.css';
import {REACT_APP_ON_CALL_PROVIDERS_COMPONENT_HANDLE} from "../../../../env";

const EstimatedTotal = ({ selectedAddOns = [], estimatedTotal, addOns = [] }) => {
  const onCallHandle = REACT_APP_ON_CALL_PROVIDERS_COMPONENT_HANDLE;

  // Build the display list
  let itemsToDisplay = [];

  // First, check if we have the on-call-providers in addOns
  const onCallAddOn = addOns.find(a => a?.handle === onCallHandle);

  if (onCallAddOn) {
    // Check if it's already in selectedAddOns
    const selectedOnCall = selectedAddOns.find(a => a?.handle === onCallHandle);

    if (selectedOnCall) {
      // Use the selected version (has quantity from users)
      itemsToDisplay.push(selectedOnCall);
    } else {
      // Add it with quantity 0
      itemsToDisplay.push({
        id: onCallAddOn.id,
        name: onCallAddOn.name,
        handle: onCallAddOn.handle,
        quantity: 0
      });
    }
  }

  // Add all other selected add-ons (that aren't on-call-providers)
  const otherAddOns = selectedAddOns.filter(a => a?.handle !== onCallHandle);
  itemsToDisplay.push(...otherAddOns);

  const sortedAddons = itemsToDisplay;

  return (
    <>
      <h2 className={styles.stepTitle}>Estimated Total</h2>
      <div className={styles.formContent}>
        <div className={styles.accordionGroup}>
          <Accordion title="Selections" defaultOpen={true}>
            {sortedAddons.length === 0 ? (
              <div className={styles.noLineItems}>No add-ons selected.</div>
            ) : (
              <ul className={styles.lineItemList}>
                {sortedAddons.map((prod) => (
                  <li key={prod.id} className={styles.lineItem}>
                    <span className={styles.lineItemName}>{prod.name}</span>
                    <span className={styles.lineItemDetails}>
                      {prod.quantity > 1 || prod.handle === REACT_APP_ON_CALL_PROVIDERS_COMPONENT_HANDLE ? `( ${prod.quantity} )` : 'Selected'}
                    </span>
                  </li>
                ))}
                <li className={`${styles.lineItem} ${styles.totalRow}`}>
                  <span className={styles.lineItemName}>Estimated Total</span>
                  <span className={styles.lineItemDetails}>
                    ${estimatedTotal.toFixed(2)}
                  </span>
                </li>
              </ul>
            )}
          </Accordion>
        </div>
        <p className={styles.instructionText}>
          Continue to provide payment information
        </p>
      </div>
    </>
  );
};

export default EstimatedTotal;
